import { render, staticRenderFns } from "./VueTypeaheadBootstrapListItem.vue?vue&type=template&id=0d97cddd&scoped=true&"
import script from "./VueTypeaheadBootstrapListItem.vue?vue&type=script&lang=js&"
export * from "./VueTypeaheadBootstrapListItem.vue?vue&type=script&lang=js&"
import style0 from "./VueTypeaheadBootstrapListItem.vue?vue&type=style&index=0&id=0d97cddd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d97cddd",
  null
  
)

export default component.exports